import { cn } from "@/lib/utils";
import { Button } from "./ui/button";

interface ButtonItem {
  id: string;
  text?: string;
  icon?: React.ReactNode;
  disabled?: boolean;
}

interface ButtonGroupProps {
  selectedId?: string;
  items: ButtonItem[];
  onClick: (id: string) => void;
}

export const ButtonGroup = ({ selectedId, items, onClick }: ButtonGroupProps) => {
  return (
    <div className="flex overflow-hidden rounded-lg">
      {items.map((item, index) => (
        <Button
          key={index}
          onClick={() => onClick(item.id)}
          disabled={item.disabled}
          variant={"outline"}
          size="sm"
          className={cn(
            "rounded-none first:rounded-l-lg last:rounded-r-lg",
            index > 0 && "-ml-[1px]",
            selectedId === item.id && "font-bold"
          )}
          type="button"
        >
          {item.icon}
          {item.text}
        </Button>
      ))}
    </div>
  );
};
